module.exports = __webpack_public_path__ + "static/media/Group 6536.27065d11.svg";